<template>
    <v-card width="100%">
        <v-card-title class="justify-center pt-0 pb-2"><h2>Virtual assistants overview</h2></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            Number of assistants: {{ assistants.length }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn color="primary" small :disabled="disableAll!==0" @click="refreshAll">Refresh Assistants</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" small :disabled="disableAll!==0" @click="createAssistant">Create Assistant</v-btn>
            <v-btn color="primary" small :disabled="disableAll!==0" @click="createDefaultAssistants">Create Default Assistants</v-btn>
            <v-btn color="error" small :disabled="disableAll!==0" @click="confirmAll">Delete All Assistants</v-btn>
        </v-card-actions>
        <cardVirtualAssistantEdit ref="cardVirtualAssistantEdit" @updateData="updateData"/>
        <cardConfirm ref="cardConfirm" @confirmAction="confirmAction" />
    </v-card>
</template>

<script>
    import cardConfirm from "@/components/syst/openai/cardConfirm.vue";
    import cardVirtualAssistantEdit from "@/components/syst/openai/cardVirtualAssistantEdit.vue";

    export default {
        components: {
            cardConfirm,
            cardVirtualAssistantEdit,
        },
        props: {
            assistants: {
                required: true,
            },
            models: {
                required: true,
            }
        },
        data() {
            return {
                disableAll: 0,
            }
        },
        methods: {              
            refreshAll() {
                this.$emit("updateData", "refresh");
            },
            updateData(data) {
                this.$emit("updateData", data);
            },
            createAssistant() {
                let newAssistant = {
                    id: "",
                    name: "",
                    model: "gpt-4o-mini",
                    description: "",
                    temperature: 0.5,
                    instructions: "",
                }
                this.$refs.cardVirtualAssistantEdit.openDialog(newAssistant, this.models);
            },
            confirmAll() {
                this.$refs.cardConfirm.openDialog("You are about to delete all assistants", "deleteAll");
            },
            confirmAction(action) {
                switch (action) {
                    case "deleteAll":
                        this.deleteAll();
                        break;
                    default:
                }
            },
            createDefaultAssistants() {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/createAssistants.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "createAssistants",
                    },
                    createAssistants: {},
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.createAssistants.text,
                            color: res.data.createAssistants.color,
                        });
                        this.$emit("updateData", "refresh");
                        this.disableAll -= 1;
                    }
                });
            },
            deleteAll() {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/deleteAssistants.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteAssistants",
                    },
                    deleteAssistants: this.assistants,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.deleteAssistants.text,
                            color: res.data.deleteAssistants.color,
                        });
                        this.$emit("updateData", "refresh");
                        this.disableAll -= 1;
                    }
                });
            }
        }
    }
</script>
